import { defineFcm } from '../shared/factory';

export const FCM_DARK_MODE_ENABLED = defineFcm('dark_mode_enabled').asBoolean().withDefault(false).toConfig({
	owner: 'squad-site-platform',
	scope: 'corgi-front-end',
	context: 'Dark mode',
	description: 'When true, dark mode can be enabled',
	import: false,
});
